// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"543591e4","453":"ac28e78b"}[chunkId] + ".chunk.js";
};